import { createSelector } from "@ngrx/store";
import { IConnection } from "src/app/models/connection";
import { IAppState } from "../states/app";

export const selectConnectionState = createSelector(
  (state: IAppState) => state.connection,
  (state: IConnection) => state.connected,
);
